
<section class="content">
  <div class="invoice-POS">
    <div  id="pdfTable" #pdfTable>
      <div id="top" >
        <div class="info rotate">
          <div class="tname">Pratik Joshi</div>
          <div class="tno">P-2022112</div>
          <div class="tdate">03/02/2023</div>
        </div><!--End Info-->
      <div class="rotate_watermark">
        <div class="watermark"><img alt="logo" class="watermark-img" src="../../../../../assets/images/logo-1.jpg"></div>
      </div>
      </div>
    </div>
    <!-- <button class="btn btn-primary" (click)="downloadAsPDF();">Export To PDF</button> -->
  </div>
</section>